import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Coluna } from '@components/table/table.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-dashboard-table',
  templateUrl: './dashboard-table.component.html',
  styleUrls: ['./dashboard-table.component.scss']
})
export class DashboardTableComponent {
  @Input() items: any[] = [];
  @Input() colunas: Coluna[] = [];
  @Input() emptyMessage: string = 'Nenhum dado encontrado';
  @Input() isLoading: boolean = false;
  
  @Input() hasDataAll: boolean = false;
  @Input() paginatorLength: number = 0;
  @Input() pageSize: number = 5;
  @Input() pageIndex: number = 0;
  @Input() pageSizeOptions: number[] = [5, 10, 25];

  @Output() pageChanged = new EventEmitter<PageEvent>();

  onPaginate(event: PageEvent) {
    this.pageChanged.emit(event);
  }
}
